<script>
    import { onMount } from 'svelte';
    import { notifier } from '@beyonk/svelte-notifications'
    import {getJWT} from './Utilities/Session.svelte';
    import Loader from "./Components/Loader.svelte";
    import Assessment from './Models/assessmentModel';
    import AssessmentNav from "./Components/AssessmentNav.svelte";
    import RiskToggle from './Components/RiskToggle.svelte';
    import {forms} from './lib/forms';

    import FindingsReview from './Components/Report/FindingsReview.svelte';
    import ServiceRecommendations from './Components/Report/ServiceRecommendations.svelte';
    import PositiveControls from './Components/Report/PositiveControls.svelte';
    import KeyRecommendations from './Components/Report/KeyRecommendations.svelte';
    import PolicyStatus from './Components/Report/PolicyStatus.svelte';

    import Form from './Forms/Form.svelte';

    import AssessmentReport from './Components/Report/AssessmentReport.svelte'

    export let params;
    let loading = false;
    let include_evidence = false;

    let assessment_model;
    let assessment;

    let scores;
    let top10;

    let client_name, client_short_name, client_logo, start_date, end_date, privileged;

    let section = "Overview";

    onMount(async () => {
        let assessment_details = await Assessment.getAssessmentDetails(params.id);
        assessment_model = new Assessment(assessment_details);

        assessment = assessment_model.store;
    });

    function save_data() {
        let det = $assessment.details;
        det.scores = scores;
        det.top10 = top10;

        det.client = client_name;
        det.short_name = client_short_name;
        det.logo_url = client_logo;
        det.privileged = privileged ;
        det.start_date = start_date;
        det.end_date = end_date;

        return Assessment.saveDetails(det);
    }

    function load_data(a) {
        if (!a) return
        scores = a.details.scores || [
            {
                name: "Identify",
                subcategories: [
                    {
                        name: "Asset Management (ID.AM)",
                        target: 3,
                        client: 3
                    },
                    {
                        name: "Business Environment (ID.BE)",
                        target: 3,
                        client: 3
                    },
                    {
                        name: "Governance (ID.GV)",
                        target: 4,
                        client: 3
                    },
                    {
                        name: "Risk Assessment (ID.RA)",
                        target: 4,
                        client: 3
                    },
                    {
                        name: "Risk Management Strategy (ID.RM)",
                        target: 3,
                        client: 3
                    },
                    {
                        name: "Supply Chain Risk Management (ID.SC)",
                        target: 3,
                        client: 3
                    }
                ]
            },
            {
                name: "Protect",
                subcategories: [
                    {
                        name: "Identity Management, Authentication, and Access Control (PR.AC)",
                        target: 4,
                        client: 3
                    },
                    {
                        name: "Awareness and Training (PR.AT)",
                        target: 5,
                        client: 3
                    },
                    {
                        name: "Data Security (PR.DS)",
                        target: 4,
                        client: 3
                    },
                    {
                        name: "Information Protection Processes and Procedures (PR.IP)",
                        target: 3,
                        client: 3
                    },
                    {
                        name: "Maintenance (PR.MA)",
                        target: 3,
                        client: 3
                    },
                    {
                        name: "Protective Technology (PR.PT)",
                        target: 3,
                        client: 3
                    }
                ]
            },
            {
                name: "Detect",
                subcategories: [
                    {
                        name: "Anomalies and Events (DE.AE)",
                        target: 4,
                        client: 3
                    },
                    {
                        name: "Security Continuous Monitoring (DE.CM)",
                        target: 4,
                        client: 3
                    },
                    {
                        name: "Detection Processes (DE.DP)",
                        target: 3,
                        client: 3
                    }
                ]
            },
            {
                name: "Respond",
                subcategories: [
                    {
                        name: "Response Planning (RS.RP)",
                        target: 4,
                        client: 3
                    },
                    {
                        name: "Communications (RS.CO)",
                        target: 3,
                        client: 3
                    },
                    {
                        name: "Analysis (RS.AN)",
                        target: 3,
                        client: 3
                    },
                    {
                        name: "Mitigation (RS.MI)",
                        target: 3,
                        client: 3
                    },
                    {
                        name: "Improvements (RS.IM)",
                        target: 3,
                        client: 3
                    }
                ]
            },
            {
                name: "Recover",
                subcategories: [
                    {
                        name: "Recovery Planning (RC.RP)",
                        target: 4,
                        client: 3
                    },
                    {
                        name: "Improvements (RC.IM)",
                        target: 3,
                        client: 3
                    },
                    {
                        name: "Communications (RC.CO)",
                        target: 3,
                        client: 3
                    }
                ]
            }
        ];

        top10 = a.details.top10 || {
            policies: "low",
            ciso: "low",
            training: "low",
            pentesting: "low",
            ir_plan: "low",
            vuln: "low",
            mfa: "low",
            siem: "low",
            admin: "low",
            email: "low"
        }

        client_name = a.details.client;
        client_short_name = a.details.short_name;
        client_logo = a.details.logo_url;
        privileged = a.details.privileged;
        start_date = a.details.start_date;
        end_date = a.details.end_date;
    }

    function handle_save() {
        save_data().then(() => {
            notifier.success("Saved!")
        })
    }

    function saveConclusion(evt) {
        Assessment.saveDetails(evt.detail).then(() => {
            notifier.success("Assessment Saved")
        });
    }

    async function generate_report() {
        loading = true;
        await save_data();
        let jwt = await getJWT();

        let url = new URL(`${window.location.origin}/generate/`)

        if (include_evidence) {
            url.searchParams.append("include_evidence", "true");
        }

        let data = $assessment;
        data.model = undefined;

        let res = await fetch(url, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                'Authorization': `Bearer ${jwt}`,
                "content-type": "application/json"
            }
        });

        if (res.status != 200) {
            notifier.danger(res.statusText);
            loading = false;
        } else {

            let current_datetime = new Date()
            let formatted_date = "_" + current_datetime.getFullYear() + "_" + (current_datetime.getMonth() + 1) + "_" + current_datetime.getDate()

            res.blob().then((blob) => {
                let url = URL.createObjectURL(blob);
                let link = document.createElement("a");
                link.href = url;
                link.download = $assessment.details['client'] + formatted_date + ".zip";
                link.target = "_new";

                link.click();

                URL.revokeObjectURL(url);
            }).catch(e => {
                notifier.danger(e);
            }).finally(() => {
                loading = false;
            })
        }
    }

    $: load_data($assessment);
</script>
<Loader loading={!$assessment}>
    <Loader loading={loading} message="Generating Report...">
        {#if $assessment.assessment_type_data.report_sections?.length}
            <div class="container viewport is-fluid">
                <AssessmentReport {assessment} {assessment_model} {params}></AssessmentReport>
            </div>
        {:else}

            {#if $assessment.assessment_type_data.assessment_type_category == "Controls Assessment"}
                <div class="columns">
                    <div class="column is-2">
                        <AssessmentNav assessment_id={$assessment.details._id} />
                        <h1 class="title is-1">
                            {$assessment.details.name}
                        </h1>
                    </div>
                </div>
                <div class="content">
                    <h1 class="title is-1">
                        Generate Report
                        <span class="buttons is-pulled-right">
                            <span class="button is-primary" on:click={generate_report}>
                                Generate
                            </span>
                        </span>
                    </h1>
                </div>
            {:else}
                <div class="columns">
                    <div class="column is-2">
                        <AssessmentNav assessment_id={$assessment.details._id} />
                        <h1 class="title is-1">
                            {$assessment.details.name}
                        </h1>
                        <aside class="menu">
                            <p class="menu-label">Report Sections</p>
                            <ul class="menu-list">
                                <li><span class="link" on:click={() => section = "Overview"} class:is-active={section == "Overview"}>Overview</span></li>
                                <li><span class="link" on:click={() => section = "Findings Review"} class:is-active={section == "Findings Review"}>Findings Review</span></li>
                                <li><span class="link" on:click={() => section = "Policy Review"} class:is-active={section == "Policy Review"}>Policy Review</span></li>
                                <li><span class="link" on:click={() => section = "Top 10"} class:is-active={section == "Top 10"}>Top 10</span></li>
                                <li><span class="link" on:click={() => section = "Maturity Model"} class:is-active={section == "Maturity Model"}>Maturity Model</span></li>
                                <li><span class="link" on:click={() => section = "Positive Controls"} class:is-active={section == "Positive Controls"}>Positive Controls</span></li>
                                <li><span class="link" on:click={() => section = "Service Recommendations"} class:is-active={section == "Service Recommendations"}>Service Recommendations</span></li>
                                <li><span class="link" on:click={() => section = "Conclusion"} class:is-active={section == "Conclusion"}>Conclusion</span></li>
                            </ul>
                        </aside>
                        <span></span>
                    </div>
                    <div class="column">
                        <h1 class="title is-1">
                            Generate Report
                            <span class="buttons is-pulled-right">
                                {#if section != "Overview"}
                                    <span class="button is-primary" on:click={handle_save}>Save</span>
                                {/if}

                                <span class="button is-success" on:click={generate_report}>
                                    Generate
                                </span>
                            </span>
                        </h1>
                        {#if $assessment.assessment_type_data.assessment_type_category == "controls_assessment"}
                        <label class="label">
                            Include Evidence
                            <input type="checkbox" bind:checked={include_evidence}>
                        </label>
                        {:else}
                            {#if section == "Overview"}
                                <Form fields={forms['report_overview']} data={$assessment.details} on:submit={saveConclusion} field_class="is-large" />
                            {:else if section == "Maturity Model"}
                                <table class="table NISTTable">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>NIST CSF 1.1 SUBCATEGORY</th>
                                            <th>Target Score</th>
                                            <th>Client Score</th>
                                            <th>Target Average</th>
                                            <th>Client Average</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {#each Object.keys(scores) as family}
                                            {#each scores[family].subcategories as subcategory, idx}
                                            <tr>
                                                {#if idx == 0}
                                                    <td class="is-v-centered is-h-centered function" data-field="{scores[family].name}" rowspan={scores[family].subcategories.length}>
                                                        {scores[family].name}
                                                    </td>
                                                {/if}
                                                <td>{subcategory.name}</td>
                                                <td>
                                                    <input type="number" min=1 max=5 step=0.01 bind:value={subcategory.target} tabindex="1">
                                                </td>
                                                <td>
                                                    <input type="number" min=1 max=5 step=0.01 bind:value={subcategory.client} tabindex="2">
                                                </td>
                                                {#if idx == 0}
                                                <td class="is-v-centered is-h-centered" rowspan={scores[family].subcategories.length}>
                                                    {(scores[family].subcategories.map(s => s.target).reduce((a,b) => a + b) / scores[family].subcategories.length).toPrecision(3)}
                                                </td>
                                                <td class="is-v-centered is-h-centered" rowspan={scores[family].subcategories.length}>
                                                    {(scores[family].subcategories.map(s => s.client).reduce((a,b) => a + b) / scores[family].subcategories.length).toPrecision(3)}
                                                </td>
                                                {/if}
                                            </tr>
                                            {/each}
                                        {/each}
                                    </tbody>
                                </table>
                            {:else if section == "Top 10"}
                                <div class="top10">
                                    <div class="top10_item {top10.policies}">
                                        <RiskToggle bind:value={top10.policies} />
                                        <img alt="Formal Policies" src="images/report_images/policies.png" />
                                        <span>Formal Information Security Policies and Procedures</span>
                                    </div>
                                    <div class="top10_item {top10.ciso}">
                                        <RiskToggle bind:value={top10.ciso} />
                                        <img alt="CISO" src="images/report_images/ciso.png" />
                                        <span>Dedicated Role to Oversee the Information Security Program</span>
                                    </div>
                                    <div class="top10_item {top10.training}">
                                        <RiskToggle bind:value={top10.training} />
                                        <img alt="Training" src="images/report_images/training.png" />
                                        <span>Employee Security Awareness and Training</span>
                                    </div>
                                    <div class="top10_item {top10.pentesting}">
                                        <RiskToggle bind:value={top10.pentesting} />
                                        <img alt="Penetration Testing" src="images/report_images/pentesting.png" />
                                        <span>Regular Penetration Testing and Vulnerability Assessments</span>
                                    </div>
                                    <div class="top10_item {top10.ir_plan}">
                                        <RiskToggle bind:value={top10.ir_plan} />
                                        <img alt="Incident Response Plan" src="images/report_images/ir_plan.png" />
                                        <span>Formal Incident Response Plan and Testing</span>
                                    </div>
                                </div>
                                <div class="top10">
                                    <div class="top10_item {top10.vuln}">
                                        <RiskToggle bind:value={top10.vuln} />
                                        <img alt="Vulnerability Manangent" src="images/report_images/vuln_management.png" />
                                        <span>Mature Vulnerability Management Program</span>
                                    </div>
                                    <div class="top10_item {top10.mfa}">
                                        <RiskToggle bind:value={top10.mfa} />
                                        <img alt="Multi-Factor Authentication" src="images/report_images/MFA.png" />
                                        <span>Multi-factor Authentication for All Remote Access and Cloud Connectivity</span>
                                    </div>
                                    <div class="top10_item {top10.siem}">
                                        <RiskToggle bind:value={top10.siem} />
                                        <img alt="SIEM" src="images/report_images/SIEM.png" />
                                        <span>Centralized Security Event Logging, Correlation, and Alerting</span>
                                    </div>
                                    <div class="top10_item {top10.admin}">
                                        <RiskToggle bind:value={top10.admin} />
                                        <img alt="Local Administrator Rights" src="images/report_images/local_admin.png" />
                                        <span>Restricted Local Administrator Rights to User Systems</span>
                                    </div>
                                    <div class="top10_item {top10.email}">
                                        <RiskToggle bind:value={top10.email} />
                                        <img alt="Email" src="images/report_images/email.png" />
                                        <span>Effective Email Defenses Against Phishing and Malicious Payload Delivery</span>
                                    </div>
                                </div>
                            {:else if section == "Positive Controls"}
                                <PositiveControls {assessment_model} />
                            {:else if section == "Service Recommendations"}
                                <ServiceRecommendations {assessment_model} />
                            {:else if section == "Findings Review"}
                                <FindingsReview {assessment_model} />
                            {:else if section == "Policy Review"}
                                <PolicyStatus {assessment_model} />
                            {:else if section == "Conclusion"}
                                <Form fields={forms['report_conclusion']} data={$assessment.details} on:submit={saveConclusion} field_class="is-large"></Form>

                                <KeyRecommendations {assessment_model} />
                            {/if}
                        {/if}
                    </div>
                </div>
            {/if}
        {/if}
    </Loader>
</Loader>

<style>
    .columns {
        margin: 0;
        padding:0;
    }

    .top10 {
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px;
    }

    .top10_item {
        width: 250px;
        height: 300px;
        border: 1px solid black;
        padding-bottom: 20px;
        text-align: center;
        display:flex;
        flex-direction: column;
        background-color: green;
        color: white;
        font-weight: bold;
    }

    .top10_item > span {
        padding: 0 10px;
    }

    .top10_item img {
        width: 50%;
        height: auto;
        margin: auto;
    }

    .top10 :global(.top10_item.low) {
        background-color: #00B050;
    }
    .top10 :global(.top10_item.medium) {
        background-color: #FC9D33;
    }
    .top10 :global(.top10_item.high) {
        background-color: #CD4B4B;
    }

    .key_recommendation :global(strong) {
        color: unset;
    }

    .content {
        padding: 0 .75rem;
    }
</style>